<!--
  创建时间：2024/8/23 11:31
  创建人：toyehuang
  文件描述：AdvertComp 首页广告位
-->

<template>
  <div class="advert">
    <Link :to="advData.url || ''">
      <img :src="advData.adImage" :alt="advData.title">
    </Link>
  </div>

</template>

<script>
import Link from "@/layout/components/LayoutHead/HeadNav/Link.vue";
import adApi from "@/api/ad";
import { AD_CODE } from "@/utils/constant";

export default {
  name: "AdvertComp",
  components: { Link },
  props: {
    advType: {
      type: String,
      default: "AD_A"
    }
  },
  data() {
    return {
      advData: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {
    computedAdType() {
      return AD_CODE[this.advType.toUpperCase()]
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getAdList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    getAdList() {
      adApi.page({ pageNo: 1, pageSize: 1, type: this.computedAdType }).then((res) => {
        this.advData = res.data.list[0] || {};
      });
    }
  }
};
</script>

<style scoped lang="scss">
.advert{
  width: 100%;
  height: 100px;
  &:hover{
    opacity: 0.8;
  }
  a{
    display: block;
    height: 100%;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
</style>
